const TREE = {
  good: require("./Condition=Good.png"),
  bad: require("./Condition=Bad.png"),
  ok: require("./Condition=Ok.png"),
  terrible: require("./Condition=Terrible.png"),
};

export default TREE;
